import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from '@cv-invision/core';
import { OverviewComponent } from './overview/overview.component';
import { PdfReviewComponent } from './pdf-review/pdf-review.component';
import { PhotoReviewComponent } from './photo-review/photo-review.component';
import { QualityComponent } from './quality.component';
import { OverviewSubHeaderComponent } from './overview/sub-header/overview-sub-header.component';
import { ComponentFactoryResolverService } from '@cv-invision/core';
import { DocumentLoaderGuard } from './service/document-loader.guard';
import { RevisedFieldsComponent } from './revised-fields/revised-fields.component';
import { CompGridComponent } from './1004/comp-grid/comp-grid.component';
import { VirtualTourComponent } from './virtual-tour/virtual-tour.component';
import { InReviewSectionsComponent } from './in-sections-review/in-review-sections/in-review-sections.component';
import { CvdsStructuresComponent } from './cvds/cvds-structures/cvds-structures.component';
import { InitialPageComponent } from './intial-page/initial-page.component';
import { PTableCompGridComponent } from './1004/comp-grid/p-table-comp-grid.component';

const routes: Routes = [
	{
		path: 'quality',
		canActivate: [RoleGuard],
		canActivateChild: [DocumentLoaderGuard],
		component: QualityComponent,
		resolve: {
			componentFactoryResolver: ComponentFactoryResolverService
		},
		data: {
			module: 'quality'
		},
		children: [
			{ path: 'initial', redirectTo: 'initial/' },
			{
				path: 'initial/:orderId',
				component: InitialPageComponent,
				data: {
					subComponentShow: false
				}
			},
			{ path: 'revisions', redirectTo: 'revisions/' },
			{
				path: 'revisions/:orderId',
				component: RevisedFieldsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'overview', redirectTo: 'overview/' },
			{
				path: 'overview/:orderId',
				component: OverviewComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'pdfreview', redirectTo: 'pdfreview/' },
			{
				path: 'pdfreview/:orderId',
				component: PdfReviewComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'photoreview', redirectTo: 'photoreview/' },
			{
				path: 'photoreview/:orderId',
				component: PhotoReviewComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'subject', redirectTo: 'subject/' },
			{
				path: 'subject/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'neighborhood', redirectTo: 'neighborhood/' },
			{
				path: 'neighborhood/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'improvements', redirectTo: 'improvements/' },
			{
				path: 'improvements/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'projectinformation', redirectTo: 'projectinformation/' },
			{
				path: 'projectinformation/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'projectanalysis', redirectTo: 'projectanalysis/' },
			{
				path: 'projectanalysis/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'unitdescription', redirectTo: 'unitdescription/' },
			{
				path: 'unitdescription/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'comps', redirectTo: 'comps/' },
			// {
			// 	path: 'comps/:orderId',
			// 	component: CompGridComponent,
			// 	data: { breadcrumbComponent: OverviewSubHeaderComponent }
			// },
			{
				path: 'comps/:orderId',
				component: PTableCompGridComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'salesapproach', redirectTo: 'salesapproach/' },
			{
				path: 'salesapproach/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'costapproach', redirectTo: 'costapproach/' },
			{
				path: 'costapproach/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'incomeapproach', redirectTo: 'incomeapproach/' },
			{
				path: 'incomeapproach/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'reconciliation', redirectTo: 'reconciliation/' },
			{
				path: 'reconciliation/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'arrival', redirectTo: 'arrival/' },
			{
				path: 'arrival/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'site', redirectTo: 'site/' },
			{
				path: 'site/:orderId',
				component: InReviewSectionsComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'structures', redirectTo: 'structures/' },
			{
				path: 'structures/:orderId',
				component: CvdsStructuresComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			},
			{ path: 'virtualtour', redirectTo: 'virtualtour/' },
			{
				path: 'virtualtour/:orderId',
				component: VirtualTourComponent,
				data: { breadcrumbComponent: OverviewSubHeaderComponent }
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class QualityRoutingModule {}
